export const config = {
  url: {
    apiEndPoint: "https://parea-cliente.thopenergy.com.br/api",
    urlLogout: "https://pparceria.thopenergy.com.br/tim/logout",
    urlUpload: "https://parea-cliente.thopenergy.com.br/api",
    urlPortal: "https://parea-cliente.thopenergy.com.br/tim/aquisicao",
    urlPortalLogin: "https://parea-cliente.thopenergy.com.br/tim/portal/login",
    urlCampanhaTim: "https://www.tim.com.br",
    urlLoginPortal: "https://parea-cliente.thopenergy.com.br/tim/portal/login",
    urlSiteThopen: "https://thopenergy.com.br/",
  },
  simulacao: {
    idCanal: 9,
    situacao: "1",
    tipolead: "F",
    idTipoProduto: "1",
    tipoParceiro: 8,
    tipoCanal: 9,
    idTagClienteTim: "4",
    idTagNaoClienteTim: "5",
    idSimuladorTipo: 4,
    dispararSms: true,
  },
};
